const Config = [
  {
    path: '/ecommerce/settings/configs',
    name: 'settings-config',
    component: () => import(/* webpackChunkName: "merchant_configs" */ '../views/Configurations.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Settings Configurations',
          path: '/ecommerce/settings/settings',
        },
      ],
    },
    children: [],
  },
  {
    path: '/ecommerce/settings/profile',
    name: 'settings-profile',
    component: () => import(/* webpackChunkName: "merchant_profile" */ '../views/MerchantProfile.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Profile Configurations',
          path: '/ecommerce/settings/profile',
        },
      ],
    },
    children: [],
  },
  {
    path: '/ecommerce/settings/images-uploads',
    name: 'images-uploads',
    component: () => import(/* webpackChunkName: "images_upload" */ '../views/ImagesUpload.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Image Uploads',
          path: '/ecommerce/settings/images-uploads',
        },
      ],
    },
    children: [],
  },
];

export default Config;
